import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * @typedef {object} ObservationReportPageRedirectorData
 * @property {number} [eventId]
 * @property {number} [observedUserId]
 */

/**
 * @typedef {object} ObservationReportPageRedirectorProps
 * @property {ObservationReportPageRedirectorData} [data]
 */

/**
 * @param {ObservationReportPageRedirectorProps} props
 */
const ObservationReportPageRedirector = props => {
  const { data } = props;
  const { eventId, observedUserId } = data;
  return <Navigate to={`/observation-report/${eventId}/${observedUserId}`} />;
};

export default ObservationReportPageRedirector;
